import { useMemo } from 'react';

import { useAuthSession } from 'hooks/useAuthSession';

type UseAuthReadyOptions = {
  requireProducer?: boolean;
};

export function useAuthReady(options: UseAuthReadyOptions = {}) {
  const { requireProducer = false } = options;
  const { tokens, user } = useAuthSession();

  return useMemo(() => {
    const hasToken = !!tokens?.token;
    const hasUser = !!user;
    const isProducer = !!user?.is_producer;

    const isReady = hasToken && hasUser && (!requireProducer || isProducer);

    return {
      tokens,
      user,
      hasToken,
      hasUser,
      isProducer,
      isReady,
      isLoading: !hasToken || !hasUser
    };
  }, [tokens, user, requireProducer]);
}
